import React from 'react'
import PageHeader from '../components/PageHeader'
import PageContent from '../components/PageContent'
import Blog from '../components/Blog'
import { useSelector } from 'react-redux';

function AboutUsPage() {
  const store = useSelector((state) => state.auth.store);
  return (
    /*
     {
          "title": "Vision & Mission",
          "link": "/about/vision-mission/"
        },
        {
          "title": "We value their Services",
          "link": "#",
          "subMenu": [
            {
              "title": "Our Past Principals",
              "link": "/about/we-value-their-services/our-past-principal/"
            },
            {
              "title": "Our Past Faculties",
              "link": "/about/we-value-their-services/our-past-faculties/"
            }
          ]
        }
    */
    <div>
      <PageHeader title="About Us" />
      <PageContent elem={<Blog image={store.about_image} content2={"The college has a total land area of 14.36 acres out of which the built-up area is 8899.11sq. meters. There are nine lecture rooms, four well-equipped laboratories, examination room, games room, NSS room playground, badminton court etc. There is a central library having a collection of 17,457 books and journals. Located in a rural area and catering to the needs of students belonging to different sections of society for more than twenty-nine years, the college has earned an esteemed reputation and is making notable contribution in the development of people and society."} content={"The college is affiliated to Bundelkhand University, Jhansi (UP). Because of the only government college of Science and Commerce in Lalitpur district, affectionate relation between students and teachers and tradition of quality education, it attracts students for higher education in friendly environment. Presently, there are two faculties of Science and Commerce with students, teaching staff and administrative/technical/supporting staff. There is faculty of science with five departments - Botany, Chemistry, Mathematics, Physics and Zoology, and faculty of Commerce with UG & PG Programs. The college is affiliated for B.Sc. Degree (Graduate Course) in Bio Group-Botany, Zoology, Chemistry and Mathematics group, Mathematics Group-Physics, Mathematics, Chemistry and B.Com. The M.Sc. (Post Graduate Course) in Botany, Chemistry, Mathematics, Physics and Zoology and M.Com courses started from 2013 academic session. The College also recognized under 2f & 12B of UGC Act."} />}/>
    </div>
  )
}

export default AboutUsPage